import { useSelector } from "react-redux";
import { isManagingAttorney } from "../../../../lib/primaryItemScripts";
import ItemSimple from "../Shared/ItemSimple";
import DocumentsPannel from "./documents/DocumentsPannel";
import PracticesUpload from "./practicesupload/PracticesUpload";

import classes from './ProcoDocsItem.module.css'
import { useUserTabEditPermissionDisabled } from "../../../../lib/usersPermissions";
import RequestsMain from "./requests/RequestsMain";
import ChangeAtty from "./ChangeAtty";

export default function ProcoDocsItem({uploadedFile, inWorkQ}) {
    let userPermissionUpload = useUserTabEditPermissionDisabled('procodocs_documents_upload')
    let userPermissionUpdate = useUserTabEditPermissionDisabled('procodocs_documents_update')
    let userPermissionDelete = useUserTabEditPermissionDisabled('procodocs_documents_delete')
    let userPermissionRestore = useUserTabEditPermissionDisabled('procodocs_documents_restore')
    let userPermissionHardDelete = useUserTabEditPermissionDisabled('procodocs_documents_hard_delete')
    const storeCase = useSelector(state => state.case.activeCase)
    const activeCase = inWorkQ || storeCase

    const selectedProcoDocsAttorney = useSelector(state => state.attorney.selectedProcoDocsAttorney)

    if (!activeCase) {
        return null
    }

    const caseAttorneyId = selectedProcoDocsAttorney ? selectedProcoDocsAttorney : isManagingAttorney(activeCase)?.id
    const attyData = selectedProcoDocsAttorney
        ? activeCase.attorneys?.find(attorney => attorney.id == selectedProcoDocsAttorney)
        : isManagingAttorney(activeCase)

    return <>
        <div className="relative">
            <ItemSimple>
                
                <div className={classes.container}>
                    <DocumentsPannel uploadedFile={uploadedFile} uploadPermission={userPermissionUpload} updatePermission={userPermissionUpdate} deletePermission={userPermissionDelete} restorePermission={userPermissionRestore} hardDeletePermission={userPermissionHardDelete} caseAttorneyId={caseAttorneyId}/>
                    <div className={classes.sidebar}>
                        <div className={classes.sidebar_row}>
                            <ChangeAtty activeCase={activeCase} />
                        </div>
                        <div className={classes.sidebar_row}>
                            <PracticesUpload caseAttorneyId={caseAttorneyId} attyData={attyData} uploadPermission={userPermissionUpload} updatePermission={userPermissionUpdate} activeCase={activeCase}/>
                        </div>
                        <div className={classes.sidebar_row}>
                            <RequestsMain activeCase={activeCase} />
                        </div>
                    </div>
                </div>
            </ItemSimple>
            
        </div>
    </>
}
